module.exports = __webpack_public_path__ + "static/media/notfound.b11b06f0.svg";